/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */

import { Location } from "@angular/common";
import { Component, Output, EventEmitter } from "@angular/core";
import { GenericFormComponent } from "../../../forms/generic-form/generic-form.component";
import { TaxInventoryCategory } from "./tax-inventory-category";
import { TaxInventoryCategoryService } from "./tax-inventory-category.service";
import { Router, ActivatedRoute } from "@angular/router";
import { UntypedFormBuilder } from "@angular/forms";
import { DBService } from "../../../shared/services/db.service";
import { MessageService, ConfirmationService } from "primeng/api";
import { AlertMessagesService } from "../../../shared/services/alert-messages.service";
import { AppSettingsStorageService } from "../../../shared/app-settings-storage.service";
import { AppComponent } from "src/app/app.component";

@Component({
  selector: "taku-tax-inventory-category",
  templateUrl: "./tax-inventory-category.component.html",
  styleUrls: ["./tax-inventory-category.component.scss"],
})
export class TaxInventoryCategoryComponent extends GenericFormComponent {
  @Output() dialogClosed = new EventEmitter<any>();

  initForm() {
    this._model = "taxInventoryCategory";
    this._object = new TaxInventoryCategory();
    this._myForm = this.fb.group(new TaxInventoryCategory());
  }

  constructor(
    public taxCategoryService: TaxInventoryCategoryService,
    protected _router: Router,
    public fb: UntypedFormBuilder,
    public dbService: DBService,
    protected location: Location,
    public _route: ActivatedRoute,
    protected messageService: MessageService,
    protected alertMessage: AlertMessagesService,
    protected confirmationService: ConfirmationService,
    appSettings: AppSettingsStorageService
  ) {
    super(_router, fb, dbService, location, _route, messageService, alertMessage, confirmationService, appSettings);
  }

  initValidation() {
    this._validation = this.taxCategoryService.getValidationRules();
  }

  closeModal() {
    this.dialogClosed.emit();
  }
}

/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */
